import { PaymentState } from 'scenes/payments/types';
import { ReduxAction } from './paymentReducer';
import { PaymentActions } from './paymentTypes';

export const updateState = (state: Partial<PaymentState>): ReduxAction => ({
  type: PaymentActions.UPDATE_RESPONSE,
  payload: state,
});

export const updatePayment = (state: Partial<PaymentState>): ReduxAction => ({
  type: PaymentActions.UPDATE_PAYMENT,
  payload: state,
});

export const resetPayment = (): ReduxAction => ({
  type: PaymentActions.RESET_PAYMENT,
  payload: {},
});
